var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ad-box"},[_c('el-carousel',{attrs:{"height":"245px"}},_vm._l((_vm.list),function(item,index){return _c('el-carousel-item',{key:index},[_c('a',{attrs:{"href":item.link,"target":"_blank"}},[_c('div',{staticClass:"ad-item",style:({ backgroundImage: 'url(' + item.url + ')' })})])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/practice/ad/top.vue?vue&type=template&id=4a4c1962&scoped=true
// module id = null
// module chunks = 